import { handleValidateAndDispatchAccount, handleConnectedDepositMode, maybeTriggerSync } from '../submitUtils';

export default async function handleMetalsSubmit({ formValues, dispatch, setLoading, category }) {
  const flattened = await handleConnectedDepositMode({ ...formValues }, { dispatch });
  const { resultDispatch, payload } = await handleValidateAndDispatchAccount({ category, userInput: flattened, dispatch, setLoading });
  const accountId = resultDispatch?.payload?.accounts?.[0]?.id;
  if (accountId) {
    maybeTriggerSync({ payload, category, dispatch, accountId });
  }
}
